import {
	ATTENDEES_PDF,
	PARTICIPATION,
	SCAN,
	ADD_ONE,
	CLEAR_ALL,
	CLEAR_ONE,
	UPDATE_ONE,
	EXPORT_STATUS_READY_STRING,
	PAGE_CHECKPOINTS,
	PAGE_REPORT
} from "actions/api/exports/actions";
import Export from "models/export";

/*SIDE PART FOR THE "TYPE" PROPERTY */
export const countScansFromState = state =>
	countTypeFromState("type", SCAN)(state);

export const countParticipationsFromState = state =>
	countTypeFromState("type", PARTICIPATION)(state);

export const countAttendeesFromState = state =>
	countTypeFromState("type", ATTENDEES_PDF)(state);

/*SIDE PART FOR THE "page" PROPERTY */
export const countCheckpointsPageFromState = state =>
	countTypeFromState("page", PAGE_CHECKPOINTS)(state);

export const countReportPageFromState = state =>
	countTypeFromState("page", PAGE_REPORT)(state);

/**
 * Count the occurences of the process that you would like know
 * by type and value
 * @param  {String} type - The property of the object
 * @param  {String} value - The value to compate to the property found
 * @return {Number} - The number of occurences that exists actually in the state
 */
export const countTypeFromState = (type, value) => {
	return state =>
		Object.keys(state.exports).filter(
			key =>
				state.exports[key][type] && state.exports[key][type] === value
		).length;
};

export const initialState = {};

const exports = (state = initialState, action) => {
	switch (action.type) {
		case ADD_ONE: {
			const newState = { ...state };

			newState[action.data.id] = {
				value: new Export(action.data),
				last_update: new Date(),
				type: action.data.process,
				status: EXPORT_STATUS_READY_STRING,
				...(action.options || {})
			};

			return newState;
		}
		case UPDATE_ONE: {
			const newState = { ...state };

			newState[action.data.id] = {
				...newState[action.data.id],
				value: new Export(action.data),
				last_update: new Date(),
				...(action.options || {})
			};

			return newState;
		}
		case CLEAR_ONE: {
			const newState = { ...state };

			delete newState[action.id];

			return newState;
		}
		case CLEAR_ALL:
			return initialState;
		default:
			return state;
	}
};

export default exports;
